import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Finished"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M280.992 754.016L691.008 167.008q11.008-15.008 29.504-13.504t26.016 18.016-2.496 32.512L314.016 817.024q-8 11.008-20.992 13.504t-24-5.504l-231.008-172.992q-10.016-8-12-20.992t6.016-24 20.992-12.512 24 6.496zM736 448q-14.016 0-23.008-8.992T704 416t8.992-23.008T736 384h192q14.016 0 23.008 8.992T960 416t-8.992 23.008T928 448h-192z m-128 192q-14.016 0-23.008-8.992T576 608t8.992-23.008T608 576h320q14.016 0 23.008 8.992T960 608t-8.992 23.008T928 640H608z m-128 192q-14.016 0-23.008-8.992T448 800t8.992-23.008T480 768h448q14.016 0 23.008 8.992T960 800t-8.992 23.008T928 832H480z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var finished = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\finished.vue"]]);

export { finished as default };
